import Toggle from './elements/Toggle'
import RadioList from './elements/RadioList'
import CheckboxList from './elements/CheckboxList'
import Number from './elements/Number'
import Date from './elements/Date'
import AutocompleteText from './elements/Autocomplete'

export const componentsMap = {
  toggle: Toggle,
  checkbox: CheckboxList,
  radio: RadioList,
  number: Number,
  date: Date,
  autocomplete: AutocompleteText
}

export const ITEMS_OFFSET = 10
export const INITIAL_ITEMS_COUNT = 10
